<template>
    <div class="mb-8 space-y-2 max-w-7xl mx-auto">
        <div class="flex items-center justify-between bg-gray-50 py-2 px-3">
            <h4 class="text-lg text-center font-medium">{{ $t('Time List') }}</h4>
            <div class="flex justify-end">
                <button
                    class="bg-blue-500 text-white border border-blue-500 hover:border-blue-600 hover:bg-white hover:text-blue-800 transition duration-150 text-sm rounded px-3 py-2"
                    @click="open = true"
                >
                    {{ $t('Create New Time') }}
                </button>
            </div>
        </div>

        <modal :closable="true" @close="closeModal" :title="$t('Create New Time')" :open="open">
            <div slot="content">
                <span
                    class="my-12 flex items-center justify-center w-full border border-transparent bg-green-400 font-medium text-sm text-white px-4 py-3 rounded focus:outline-none focus:shadow-outline"
                    v-if="submitted"
                >
                    <svg
                        class="w-5 h-5 text-white mr-1"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    {{ $t('Submitted') }}</span
                >
                <form v-else class="pt-6 pb-10 space-y-4" @submit.prevent="createGiv">
                    <div class="md:flex items-center space-y-2 md:space-y-0 md:space-x-3">
                        <section class="flex-1 space-y-1 flex flex-col">
                            <label for="givKind" class="text-sm">{{ $t('Time Name (JP)') }}</label>
                            <input
                                placeholder="平日AM"
                                :disabled="submitting || submitted"
                                v-model="formTag"
                                name="tag"
                                class="form-input"
                            />
                        </section>
                        <section class="flex-1 space-y-1 flex flex-col">
                            <label for="givKind" class="text-sm">{{
                                $t('Time Name (English)')
                            }}</label>
                            <input
                                placeholder="Weekdays am"
                                :disabled="submitting || submitted"
                                v-model="formTagEn"
                                name="tagEn"
                                class="form-input"
                            />
                        </section>
                    </div>
                    <div class="flex items-center space-x-3">
                        <section class="flex-1 space-y-1">
                            <label class="flex items-center">
                                <input
                                    type="checkbox"
                                    :disabled="submitting || submitted"
                                    v-model="formVisible"
                                    name="visible"
                                    class="form-checkbox mr-2 p-2"
                                />
                                <span class="">{{ $t('Visible') }}</span>
                            </label>
                        </section>
                    </div>
                    <section class="space-y-1 flex flex-col">
                        <span
                            v-if="formError"
                            class="bg-red-100 text-center text-sm py-1 px-1 rounded shake text-red-900 max-w-3xl overflow-auto"
                        >
                            {{ this.formError }}
                        </span>
                    </section>
                    <div>
                        <button
                            class="flex items-center justify-center w-full border border-transparent hover:bg-transparent hover:border-blue-500 hover:text-gray-900 transition duration-150 font-medium text-sm text-white px-4 py-3 rounded focus:outline-none focus:shadow-outline"
                            :class="[
                                submitting || !this.formValid
                                    ? 'pointer-events-none bg-gray-200'
                                    : 'bg-blue-500',
                            ]"
                            type="submit"
                        >
                            <spinner v-if="submitting" class="text-white" />
                            <span v-else>{{ $t('Create') }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </modal>

        <ul class="space-y-1">
            <li v-for="time in times" :key="time.id">
                <TimeCard :time="time" />
            </li>
        </ul>

        <spinner v-if="!times && $apollo.queries.times.loading" />
        <div v-else>
            <div v-if="hasMore" class="flex justify-center">
                <button
                    @click="showMore"
                    class="border flex justify-center items-center h-10 w-40 border-gray-400 hover:border-gray-800 text-sm rounded px-3 py-2"
                >
                    <spinner v-if="loadingMore" class="text-white" />
                    <span v-else>{{ $t('Load More') }}</span>
                </button>
            </div>
            <div v-else class="flex justify-center">
                <span>{{ $t('No more items to show') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import gql from 'graphql-tag'
import TimeCard from '../components/TimeCard'

const times_QUERY = gql`
    query ListTimes($limit: Int!, $offset: Int!) {
        times(limit: $limit, offset: $offset) {
            id
            tag
            tagEn
            isVisible
        }
    }
`
export default {
    components: {
        TimeCard,
    },

    apollo: {
        times: {
            query: times_QUERY,
            variables: {
                limit: 20,
                offset: 0,
            },
        },
    },
    methods: {
        async showMore() {
            this.loadingMore = true
            this.offset += this.limit
            await this.$apollo.queries.times.fetchMore({
                variables: {
                    limit: this.limit,
                    offset: this.offset,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newTimes = fetchMoreResult.times
                    const hasMore = fetchMoreResult.times.length >= this.limit

                    this.hasMore = hasMore

                    return {
                        times: [...previousResult.times, ...newTimes],
                    }
                },
            })
            this.loadingMore = false
        },

        createGiv() {
            this.submitting = true
            this.formError = null
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation($tag: String!, $tagEn: String!, $isVisible: Boolean) {
                            createTime(tag: $tag, tagEn: $tagEn, isVisible: $isVisible) {
                                id
                                tag
                                tagEn
                                isVisible
                            }
                        }
                    `,
                    variables: {
                        tag: this.formTag,
                        tagEn: this.formTagEn,
                        isVisible: this.formVisible,
                    },
                })
                .then(() => {
                    this.submitting = false
                    this.submitted = true
                })
                .catch(err => {
                    this.submitting = false
                    let errMsg = err.message
                    try {
                        errMsg = err.graphQLErrors[0].message
                    } catch (e) {
                        //
                    }
                    try {
                        errMsg = err.networkError.result.errors[0].message
                    } catch (e) {
                        //
                    }
                    this.formError = errMsg
                })
        },
        closeModal() {
            this.formError = null
            this.open = false
            if (this.submitted) {
                this.$router.go()
            }
        },
        resetData() {
            this.formName = ''
        },
    },
    computed: {
        formValid() {
            return (
                !!this.formTag && this.formTag !== '' && !!this.formTagEn && this.formTagEn !== ''
            )
        },
    },
    data() {
        return {
            formError: null,
            formTag: '',
            formTagEn: '',
            formVisible: true,
            submitting: false,
            submitted: false,
            loadingMore: false,
            open: false,
            limit: 20,
            offset: 0,
            hasMore: true,
        }
    },
    mounted() {
        if (this.$route.query.reload === true) {
            this.$apollo.queries.times.refetch()
            this.$router.push('/times')
        }
    },
}
</script>
